// Keep this list in sync with the properties defined in sprinkles.css.ts.
// Used at runtime by Box to split Sprinkles props from HTML element props.
export const SPRINKLE_KEYS = new Set([
  // Layout
  'display', 'flexDirection', 'alignItems', 'justifyContent', 'flexWrap',
  'flexShrink', 'flexGrow', 'flex', 'alignSelf', 'justifySelf',
  'gap', 'columnGap', 'rowGap',
  'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight',
  'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight',
  'width', 'height', 'minWidth', 'minHeight', 'maxWidth',
  'overflow', 'overflowX', 'overflowY',
  'position', 'inset', 'top', 'right', 'bottom', 'left', 'zIndex',
  'borderRadius', 'border',
  'cursor', 'userSelect', 'pointerEvents', 'visibility', 'opacity',
  'textDecoration',
  // Color
  'color', 'backgroundColor', 'borderColor',
  // Typography
  'fontSize', 'fontWeight', 'textAlign', 'whiteSpace', 'textOverflow',
  'fontStyle', 'textTransform', 'lineHeight',
]);
